import { useLiquity } from "src/hooks/LiquityContext";
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers";
import { ProductListRow } from "../components/Trove/PSY/ProductListRow";
import { merge } from "lodash";
import { CollateralBaseState, CollateralDerivedState, LiquityStoreState } from "@liquity/lib-base"
import { useLiquitySelector } from "@liquity/lib-react"
import { CollateralLexicons } from "src/lexicon"
import { Fragment } from "react"

type ResultSelector = Pick<CollateralBaseState & CollateralDerivedState, "price" | "total" | "trove">

const select = ({ collateralStates, collateralDerivedStates }: LiquityStoreState) => {
  const states = merge(collateralStates, collateralDerivedStates)

  const selected = Object.entries(states).reduce<{ [collateralKey: string]: ResultSelector }>((acc, [key, value]) => {
    const { price, total, trove } = value
    acc[key] = { price, total, trove }
    return acc
  }, {})
  return { ...selected }
};

export const ProductList: React.FC = () => {
  const { liquity: { connection } } = useLiquity();
  const productList = useLiquitySelector(select);

  const productsWithAddressList = Object.entries(productList).map(([key, result]) => {
    const { assetAddress } = getContractAddressByCollateralKey(connection, key)
    const lexicon = CollateralLexicons.find(lexicon => lexicon.key === key)
    return { key, lexicon, ...result, assetAddress }
  })

  return(
    <>
      <div className="flex flex-col md:flex-wrap w-full h-full md:h-[900px] md:mt-6">
        <div className="text-style-title">Borrow assets</div>
        <div className="flex flex-col gap-1 mt-8">
          {productsWithAddressList.map(({ lexicon, trove, price, total, assetAddress }, index) => (
            <Fragment key={index}>
              {!!assetAddress && !!lexicon && (
                <ProductListRow
                  lexicon={lexicon}
                  userTrove={trove}
                  price={price}
                  total={total}
                  assetAddress={assetAddress}
                />
              )}
            </Fragment>
          ))}
          </div>
      </div>
    </>
  )
};
